import { useState, useRef } from 'react';
import {
  NetYieldBuildingDetailReadModel,
  usePutSpacesByIdFinancialsMutation,
  useLazyGetStatisticsNetYieldBuildingsByIdQuery,
} from '@client/api';

export const useBuildingFinancials = (
  building: NetYieldBuildingDetailReadModel,
  startDate?: string,
  endDate?: string,
) => {
  const [buildingDetail, setBuildingDetail] = useState<NetYieldBuildingDetailReadModel>(building);
  const [operatingCost, setOperatingCost] = useState<number | null>(building.operatingCost ?? null);
  const [propertyValue, setPropertyValue] = useState<number | null>(building.propertyValue ?? null);
  const operatingCostRef = useRef(operatingCost);
  const propertyValueRef = useRef(propertyValue);
  const [putFinancials, { isLoading }] = usePutSpacesByIdFinancialsMutation();
  const [triggerGetBuilding, { isFetching }] = useLazyGetStatisticsNetYieldBuildingsByIdQuery();

  const handleSaveFinancials = () => {
    if (
      (operatingCost && operatingCost !== operatingCostRef.current) ||
      (propertyValue && propertyValue !== propertyValueRef.current)
    ) {
      putFinancials({
        id: building.spaceId,
        body: {
          operatingCost: operatingCost,
          propertyValue: propertyValue,
        },
      }).then(() => {
        if (operatingCost && propertyValue) {
          operatingCostRef.current = operatingCost;
          propertyValueRef.current = propertyValue;
          triggerGetBuilding({ id: building.spaceId, startDate, endDate }).then((result) => {
            if (result.data) setBuildingDetail(result.data);
          });
        }
      });
    }
  };

  return {
    buildingDetail,
    operatingCost,
    setOperatingCost,
    propertyValue,
    setPropertyValue,
    isLoading,
    isFetching,
    handleSaveFinancials,
  };
};
